import type { UnitType } from '../../lib/types.js';
import type { IssueMetadata } from '../../unit-meta/issuance.js';
import type { RegulatoryScheme } from '../../unit-meta/shared.js';
import { tier1Schemes } from '../constants.js';

export namespace CalculationsV1UsabilityTier {
  export const calculateUsabilityTier = ({
    batch: { regulatorySchemesDeclaration: schemes },
  }: IssueMetadata, unitType: UnitType, hasLinkedTree: boolean = false, isParentTreeClaimed: boolean = false) => {
    if (unitType === 'SAFcA') {
      if (hasLinkedTree) {
        return 3;
      }

      if (schemes.some((x: RegulatoryScheme) => tier1Schemes.includes(x))) {
        return 1;
      }
      return 2;
    }

    if (unitType === 'SAFcE') {
      if (isParentTreeClaimed) {
        return 3;
      }
      return 2;
    }
    throw new Error('Not able to calculate utility tier');
  };
}
